export const fetchData = async (url, body) => {
  try {
    const response = await fetch(url, body)
    if(!response.ok) { throw new Error(`Fetch Call Cannot Be Made`)}
    const data = await response.json()
    return data;
  } catch (error) {
    return error;
  }
};

export const fetchElasticData = async (id) => {
  try {
    const response = await fetch(`https://xzoi30dvzl.execute-api.us-east-1.amazonaws.com/dev/handle/${id}`);
    if(!response.ok) { throw new Error(`Error making call to retrieve referrer and product id`) }
    const data = await response.json();
    if(data.inventory_management === 'custom') return { referrer: data.data, product_id: data.product_id }
    return { referrer: `${data.data}?variant=${id}`, product_id: data.product_id }
  } catch (error) {
    return error;
  }
};
